import { render, staticRenderFns } from "./zbsjk-list.vue?vue&type=template&id=483f2686&"
import script from "./zbsjk-list.vue?vue&type=script&lang=ts&"
export * from "./zbsjk-list.vue?vue&type=script&lang=ts&"
import style0 from "./zbsjk-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports